import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import css from './LowBalanceNotificationBar.css';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

const LowBalanceNotificationBar = () => {
    const currentUser = useSelector(s => s.user.currentUser);
    const history = useHistory();

    if (!currentUser) return null;

    const {
        attributes: {
            profile: {
                publicData: { userType },
                privateData: { creditsAvailable = {} },
            },
        },
    } = currentUser;

    const creditsAvailableByType = creditsAvailable[userType] || 0;

    const isLowBalance = creditsAvailableByType && creditsAvailableByType < 0;

    const navigateToBalancePage = () =>
        history.push(createResourceLocatorString('BalancePage', routeConfiguration(), {}, {}));

    return isLowBalance ? (
        <aside className={css.bar}>
            <p className={css.notification}>Deine Bilanz ist nicht ausgeglichen.</p>
            <button onClick={navigateToBalancePage}>Bilanz ansehen</button>
        </aside>
    ) : null;
};

export default LowBalanceNotificationBar;
